import { handleRequest } from "../utilities/requestHandler";

export const registerUser = (req_body) =>
    handleRequest("post","/auth/register",req_body);

export const validateRegistrationEmail = (email) =>
    handleRequest("post", "/auth/validate-registration-email", { email }, { skipAuth: true });
